import { Box, Button, Skeleton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ManageMFAModal from "./ManageMFAModal";
import { fetchProfileDetails } from "../SettingsService";
import { handleErrorMessage } from "helpers/methods";
import Viewcode from "./ViewCode";
import securityStyles from "./Security.styles";
import securityTokens from "./Security.tokens";
import { MfaPhoneIcon } from "./components/SecurityIcons";

const styles = securityStyles;

interface CustomProps {
  loader: boolean;
  setLoader: Function;
}

const MFA = (props: CustomProps) => {
  const [userProfile, setUserProfile] = useState<any>({});
  const [manageMFA, setManageMFA] = useState<boolean>(false);
  const [viewQRCode, setViewQRCode] = useState<boolean>(false);
  const { loader, setLoader } = props;

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoader(true);
      const response = await fetchProfileDetails();
      setUserProfile(response);
      setLoader(false);
    } catch (error: any) {
      setLoader(false);
      handleErrorMessage(error);
    }
  };

  const enabled = !!userProfile.multiFactorLogin;

  const getActions = () =>
    loader ? (
      <Skeleton
        variant="rounded"
        width={92}
        height={securityTokens.outlinedButton.height}
        sx={{
          ml: "auto",
          flexShrink: 0,
          borderRadius: securityTokens.outlinedButton.radius,
        }}
      />
    ) : (
      <Box sx={styles.cardActions}>
        {enabled && (
          <Button
            id="mfa_view_qr_btn"
            variant="outlined"
            onClick={() => setViewQRCode(true)}
            sx={styles.neutralOutlinedButton}
          >
            View QR Code
          </Button>
        )}
        <Button
          id="mfa_manage_btn"
          variant="outlined"
          onClick={() => setManageMFA(true)}
          sx={enabled ? styles.dangerOutlinedButton : styles.outlinedButton}
        >
          {enabled ? "Disable" : "Set Up"}
        </Button>
      </Box>
    );

  return (
    <>
      <Box sx={styles.rowCard}>
        <Box sx={styles.leadingIcon}>
          <MfaPhoneIcon
            sx={styles.leadingIconGlyph}
            color={securityTokens.leadingIcon.iconColor}
            strokeWidth={securityTokens.leadingIcon.iconStrokeWidth}
          />
        </Box>

        <Box sx={styles.mfaText}>
          <Box sx={styles.mfaTitleRow}>
            <Typography component="h2" sx={styles.cardTitle}>
              Multi-Factor Authentication
            </Typography>
            {loader ? (
              <Skeleton variant="rounded" width={104} height={18} />
            ) : (
              <Box component="span" sx={styles.statusPill(enabled)}>
                {enabled ? "ENABLED" : "NOT CONFIGURED"}
              </Box>
            )}
          </Box>
          <Typography component="div" sx={styles.cardDescription}>
            Use an authenticator app to generate one-time security codes.
          </Typography>
        </Box>

        {getActions()}
      </Box>

      <ManageMFAModal
        visible={manageMFA}
        handleDialogClose={() => setManageMFA(false)}
        updateMFAStatus={(status: boolean) =>
          setUserProfile({
            ...userProfile,
            multiFactorLogin: status,
          })
        }
        mfaEnabled={userProfile.multiFactorLogin ?? false}
      />
      {viewQRCode && (
        <Viewcode
          visible={viewQRCode}
          handleDialogClose={() => setViewQRCode(false)}
        />
      )}
    </>
  );
};

export default MFA;
